import type { DisciplineBalancesStore } from './interfaces'

import { emptyDisciplineBalancesFilters } from '@helpers/discipline-balances-query'

export const actions = {
  setLoading (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['loading']): void {
    this.loading = payload
  },
  setBalances (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['balances']): void {
    this.balances = payload
  },
  setMeta (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['meta']): void {
    this.meta = payload
  },
  setFilters (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['filters']): void {
    this.filters = payload
  },
  setFilterReasons (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['filters']['reasons']): void {
    this.filters.reasons = payload
  },
  setFilterResponsible (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['filters']['responsible']): void {
    this.filters.responsible = payload
  },
  resetFilters (this: DisciplineBalancesStore): void {
    this.filters = emptyDisciplineBalancesFilters()
  },
  setCurrentPage (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['perPage']): void {
    this.perPage = payload
  },
  setModalOpen (this: DisciplineBalancesStore, payload: DisciplineBalancesStore['modalOpen']): void {
    this.modalOpen = payload
  },
  /** The list answer goes with the page it was read for: the next visit starts empty, under its loader, never
   *  showing stale rows until its own land. Filters and paging stay. */
  resetList (this: DisciplineBalancesStore): void {
    this.balances = []
    this.meta = null
  },
}
